// extracted by mini-css-extract-plugin
export default {"deactivateRow":"dhFMkgQzMUrO5W6zD1VJ"};